import ApiService from "../api.services";

const PrepostService = {
  list: async function () {
    try {
      const response = await ApiService.get("/api/prepost");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  status: async function (data) {
    try {
      const response = await ApiService.post("/api/prepost/status/dashboard", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  sro: async function (data) {
    try {
      const response = await ApiService.post("/api/prepost/status/sro", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  detail: async function (data) {
    try {
      const response = await ApiService.post("/api/prepost/status/detail", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  simple: async function (data) {
    try {
      const response = await ApiService.post("/api/prepost/simple", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async function (customer, startedAt, finishedAt, service, filter) {
    try {
      const data = {
        customer,
        startedAt,
        finishedAt,
        service,
        filter,
        post: false,
      };
      const response = await ApiService.post("/api/prepost/filter", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/prepost/id/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  dc: async function (id) {
    try {
      const response = await ApiService.get(`/api/prepost/content/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  orderservices: async function (customer, startedAt, finishedAt) {
    try {
      const period =
        startedAt && finishedAt
          ? `?startedAt=${startedAt}&finishedAt=${finishedAt}`
          : "";
      const response = await ApiService.get(
        `/api/prepost/orderservices/${customer}${period}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  plp: async function (customer, list) {
    try {
      const data = {
        list,
        customer,
      };
      const response = await ApiService.post(`/api/prepost/plp`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  xml: async function (customer, data) {
    try {
      const response = await ApiService.post(`/api/prepost/xml/create`, {
        customer,
        ...data
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  billing: async function (id) {
    try {
      const response = await ApiService.get(`/api/prepost/billing`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  tag: async function (id) {
    try {
      const response = await ApiService.get(`/api/prepost/tag/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  print: async function (tag, options) {
    try {
      const response = await ApiService.post(`/api/prepost/print`, {
        tag: tag,
        options,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  proof: async function (tag) {
    try {
      const response = await ApiService.get(`/api/prepost/proof/${tag}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  printSeparador: async function (tag, options) {
    try {
      const response = await ApiService.post(`/api/prepost/v1/print`, {
        tag: tag,
        options,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  check: async function (data) {
    try {
      const response = await ApiService.post(`/api/prepost/check`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (
    customer,
    remetenteForm,
    deliveryForm,
    contactForm,
    objectForm,
    complementForm,
    service,
    cardpost,
    dc,
    nf,
    primary = '',
    pricetable = 0,
  ) {
    try {
      const data = {
        customer,
        service,
        cardpost,
        primary,
        pricetable,
        sender: remetenteForm,
        delivery: deliveryForm,
        contact: contactForm,
        object: objectForm,
        complement: complementForm,
        dc,
        nf,
      };
      const res = await ApiService.post("/api/prepost", data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, data) {
    try {
      const res = await ApiService.put(`/api/prepost/${id}`, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  countStatus: async function (month) {
    try {
      const res = await ApiService.get(`/api/prepost/count/status/${month}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  countServices: async function (month) {
    try {
      const res = await ApiService.get(`/api/prepost/count/services/${month}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  digital: async function (tag) {
    try {
      const res = await ApiService.get(`/api/prepost/digital/${tag}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/prepost/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deleteAll: async function (data) {
    try {
      const response = await ApiService.post(`/api/prepost/deleteAll`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  values: async function (params) {
    try {
      const res = await ApiService.post(`/api/prepost/values`, params);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  validate: async function (params) {
    try {
      const res = await ApiService.post(`/api/prepost/validate`, params);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  check: async function (data) {
    try {
      const res = await ApiService.post(`/api/prepost/check`, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  export: async function (data, file) {
    try {
      const res = await ApiService.post(`/api/prepost/export/${file}`, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  checkavailable: async function (list, source, destiny) {
    const request = [];
    for (const row of list) {
      request.push(
        this.check({
          service: row.service.code,
          sourceZipcode: source,
          destinyZipcode: destiny,
        })
      );
    }

    Promise.all(request)
      .then((values) => {
        return values;
      })
      .catch((error) => {
        throw error;
      });
  },

  getByOrderserviceId: async function (order_service_id) {
    try {
      const response = await ApiService.get(
        `/api/prepost/find/byorderservice/${order_service_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deliverySuspension: async function (tag) {
    try {
      const response = await ApiService.post(`/api/prepost/suspension/${tag}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default PrepostService;

export { PrepostService };
